/**
 * Picks a popover placement that fits on screen. The placement in the tour
 * config is treated as a preference: it is kept when there is room for the
 * popover on that side, otherwise the side with room is used instead. This
 * keeps tours readable on small screens and around tall panels without
 * hand-tuning every step.
 */

// Approximate popover footprint (see .elelem-tour .ant-tour-content max-width).
const POPOVER_WIDTH = 360;
const POPOVER_HEIGHT = 200;
// Fixed chrome that covers the viewport edges (top navbar, footer).
const TOP_CHROME = 64;
const BOTTOM_CHROME = 40;

const SIDE_ORDER = ["bottom", "top", "right", "left"];

export const baseSide = (placement = "bottom") =>
  SIDE_ORDER.find((side) => placement.startsWith(side)) || "bottom";

/**
 * @param {{top:number,bottom:number,left:number,right:number}} rect target rect
 * @param {string} preferred configured placement, e.g. "top" or "bottomRight"
 * @param {{width:number,height:number}} viewport
 */
export const fitPlacement = (rect, preferred, viewport) => {
  const room = {
    top: rect.top - TOP_CHROME,
    bottom: viewport.height - BOTTOM_CHROME - rect.bottom,
    left: rect.left,
    right: viewport.width - rect.right,
  };
  const needed = {
    top: POPOVER_HEIGHT,
    bottom: POPOVER_HEIGHT,
    left: POPOVER_WIDTH,
    right: POPOVER_WIDTH,
  };
  const fits = (side) => room[side] >= needed[side];

  const wanted = preferred || "bottom";
  if (fits(baseSide(wanted))) return wanted;

  // Otherwise the first side with room; if nothing fits (a target almost as
  // big as the screen), keep the preference and let the popover overlap it.
  return SIDE_ORDER.find(fits) || wanted;
};
